import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 110px);
    >div{
        h3:hover,a:hover{
            text-decoration: underline;
            cursor: pointer;
        }
    }
`;

export default Container;
